<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title">เลือกแพ็คเกจ</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div
            v-if="game && game.field1IsActived"
            :style="`margin-bottom: ${!game.field2IsActived ? '56' : '10'}px`"
          >
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-xs-12">
                <h6>
                  <span>กรุณากรอก {{ game.field1 }}</span>
                </h6>
              </div>
            </div>
            <div class="row">
              <div
                class="
                  col-xxl-4
                  col-xl-6
                  col-lg-6
                  col-md-8
                  col-sm-8
                  col-xs-12
                  col-xs-12
                "
              >
                <a-spin :spinning="spinning">
                  <a-input-search
                    v-if="
                      playerDetail.field1 === null &&
                      code === 'pubg' &&
                      midasbuy.optionValue === 'true'
                    "
                    v-model:value="fields.field1"
                    :placeholder="'กรุณากรอก ' + game.field1"
                    enter-button="ยืนยัน"
                    size="large"
                    @change="onIdChange"
                    @search="onSearch"
                  />
                  <a-input
                    v-if="
                      playerDetail.field1 === null &&
                      (code !== 'pubg' || midasbuy.optionValue === 'false')
                    "
                    v-model:value="fields.field1"
                    :placeholder="'กรุณากรอก ' + game.field1"
                    enter-button="ยืนยัน"
                    size="large"
                    @change="onFieldChange(fields.field1, 'field1')"
                  />
                  <a-alert
                    v-if="isPlayerFoundError"
                    type="error"
                    message="ไม่พบชื่อผู้เล่นนี้"
                    banner
                    style="margin-top: 5px"
                  />
                  <a-card v-if="playerDetail.field1 !== null">
                    <div class="row">
                      <div class="col-md-9">
                        <div class="row">
                          <div class="col-md-4">
                            <span style="font-size: 14px">ชื่อผู้เล่น:</span>
                          </div>
                          <div class="col-md-8">
                            <span style="font-size: 14px">{{
                              playerDetail.field1?.name
                            }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <span style="font-size: 14px">ID ผู้เล่น:</span>
                          </div>

                          <div class="col-md-8">
                            <span style="font-size: 14px">{{
                              playerDetail.field1?.uid
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3" style="text-align: right">
                        <a style="font-size: 14px" @click="onClearSearch"
                          >แก้ไข ></a
                        >
                      </div>
                    </div>
                  </a-card>
                  <a-alert
                    v-if="!isPlayerFoundError"
                    :message="
                      'กรุณาพิมพ์เลข ' +
                      game.field1 +
                      ' ให้ถูกต้องหากไม่ถูกต้อง จะไม่สามารถยกเลิกได้'
                    "
                    type="error"
                    style="margin-top: 5px; font-size: 12px"
                  >
                  </a-alert>
                </a-spin>
              </div>
            </div>
          </div>
          <div
            v-for="field in fieldActived"
            :key="field"
            :style="`margin-bottom: ${
              field.substr(5, 1) * 1 + 1 <= 5 &&
              !game[
                field.substr(0, 5) + (field.substr(5, 1) * 1 + 1) + 'IsActived'
              ]
                ? '56'
                : '10'
            }px`"
          >
            <div v-if="game && game[field]">
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-xs-12">
                  <h6>
                    <span>กรุณากรอก {{ game[field.substr(0, 6)] }}</span>
                  </h6>
                </div>
              </div>
              <div class="row">
                <div
                  class="
                    col-xxl-4
                    col-xl-6
                    col-lg-6
                    col-md-8
                    col-sm-8
                    col-xs-12
                    col-xs-12
                  "
                >
                  <a-input
                    v-if="playerDetail[field.substr(0, 6)] === null"
                    v-model:value="fields[field.substr(0, 6)]"
                    :placeholder="'กรุณากรอก ' + game[field.substr(0, 6)]"
                    enter-button="ยืนยัน"
                    size="large"
                    @change="
                      onFieldChange(
                        fields[field.substr(0, 6)],
                        field.substr(0, 6)
                      )
                    "
                    @search="onFieldSearch(field.substr(0, 6))"
                    style="cu"
                  />
                  <a-alert
                    v-if="isPlayerFoundError"
                    type="error"
                    message="ไม่พบชื่อผู้เล่นนี้"
                    banner
                    style="margin-top: 5px"
                  />
                  <a-card v-if="playerDetail[field.substr(0, 6)] !== null">
                    <div class="row">
                      <div class="col-md-9">
                        <div class="row">
                          <div class="col-md-4">
                            <span style="font-size: 14px"
                              >{{ game[field.substr(0, 6)] }}:</span
                            >
                          </div>

                          <div class="col-md-8">
                            <span style="font-size: 14px">{{
                              playerDetail[field.substr(0, 6)].value
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3" style="text-align: right">
                        <a
                          style="font-size: 14px"
                          @click="onClearFieldSearch(field.substr(0, 6))"
                          >แก้ไข ></a
                        >
                      </div>
                    </div>
                  </a-card>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-xs-12">
              <span class="patitle">กรุณาเลือกวิธีการชำระเงิน</span>
            </div>
          </div>
          <div class="row section over-hide z-smaller" v-if="paymentLoaded">
            <div
              class="
                col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12
                pb-2
              "
              v-for="payment in paymentMethods"
              :key="payment.code"
              style="max-width: 300px"
            >
              <input
                class="checkbox-payment"
                type="radio"
                name="payment"
                v-bind:id="'payment-' + payment.code"
                @change="onSelectedPayment(payment)"
                :checked="payment.code === paymentMethodCode"
              />
              <label
                class="for-checkbox-payment"
                v-bind:for="'payment-' + payment.code"
              >
                <img v-bind:src="payment.image" alt="" />
                <span class="text"
                  >{{ payment.name }}
                  <p
                    style="margin: 0; font-size: 10px"
                    v-if="payment.code === 'wallet'"
                  >
                    คงเหลือ {{ getCurrency(wallet?.balance ?? 0) }} บาท
                  </p>
                </span>
              </label>
            </div>
          </div>
          <div v-if="paymentMethodCode === 'bank' && banksLoaded">
            <div class="row" style="margin-bottom: 16px">
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-xs-12">
                <span class="patitle">เลือกธนาคาร</span>
              </div>
            </div>
            <div class="row section over-hide z-smaller">
              <div
                class="
                  col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12
                  pb-2
                "
                v-for="b in banks"
                :key="b.code"
              >
                <input
                  class="checkbox-payment"
                  type="radio"
                  name="bank"
                  v-bind:id="'bank-' + b.code"
                  @change="onSelectedBank(b)"
                  :checked="b.code === bank.code"
                />
                <label
                  class="for-checkbox-payment"
                  v-bind:for="'bank-' + b.code"
                >
                  <img v-bind:src="b.logo" alt="" />
                  <span class="text">{{ b.bankName }}</span>
                </label>
              </div>
            </div>
          </div>
          <div
            class="row"
            style="margin-bottom: 16px"
            v-if="paymentMethodCode !== ''"
          >
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 col-xs-12">
              <span class="patitle">เลือกแพ็คเกจ</span>
            </div>
          </div>
          <div
            class="row"
            style="padding: 0 15px 0 15px"
            v-if="packagesLoaded && paymentMethodCode !== ''"
          >
            <div
              class="
                col-xxxl-1
                col-xxl-2
                col-xl-3
                col-lg-4
                col-md-6
                col-sm-8
                col-xs-12
              "
              v-for="p in packages"
              :key="p.id"
            >
              <div class="selection-wrapper">
                <label
                  v-bind:for="'selected-item-' + p.id"
                  class="selected-label"
                >
                  <input
                    type="radio"
                    name="selected-item"
                    v-bind:id="'selected-item-' + p.id"
                    @change="onSelectedPackage(p)"
                    :checked="
                      (p.id === packageId && paymentMethodCode !== 'wallet') ||
                      (p.id === packageId &&
                        paymentMethodCode === 'wallet' &&
                        (wallet?.balance ?? 0) >= p.price)
                    "
                    :disabled="
                      paymentMethodCode === 'wallet' &&
                      (wallet?.balance ?? 0) < p.price
                    "
                  />
                  <span class="icon"></span>
                  <div
                    :class="
                      'selected-content ' +
                      (paymentMethodCode === 'wallet' &&
                      (wallet?.balance ?? 0) < p.price
                        ? 'package-wallet'
                        : '')
                    "
                  >
                    <h4 style="margin-bottom: -10px; margin-top: 15px">
                      {{ p.name }}
                    </h4>
                    <h5 v-if="p.discount === 0">฿{{ p.price }}</h5>
                    <h5 v-if="p.discount > 0"><label style="text-decoration: line-through;">฿{{ p.price }}</label> ฿{{ p.price - p.discount}}</h5>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <hr />
          <div class="pull-right" style="width: 50%">
            <div class="row">
              <div class="col-md-9" style="text-align: end">
                <span>รวม: ฿{{ txtPrice }}</span>
                <br />
                <p class="category">รวมภาษีแล้ว</p>
              </div>
              <div class="col-md-3">
                <n-button
                  type="primary"
                  :disabled="isDisabledContinue"
                  @click="showSwal()"
                  >ดำเนินการต่อ</n-button
                >
              </div>
            </div>
          </div>
          <div class="pull-left"></div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import * as gameservice from "../../services/game";
import * as paymentservice from "../../services/payment";
import * as packageservice from "../../services/package";
import * as userservice from "../../services/user";
import * as orderservice from "../../services/order";
import * as configuration from "../../middleware/configuration";

import { message } from "ant-design-vue";

export default {
  methods: {
    getIsContinue() {
      this.isDisabledContinue =
        this.packageId == "" ||
        (this.code === "pubg" &&
          this.midasbuy.optionValue === "true" &&
          this.confirmedValue == "") ||
        (this.code !== "pubg" && this.fields.field1 == "") ||
        (this.paymentMethodCode == "bank" && this.bank.code === undefined) ||
        this.paymentMethodCode == "";
      this.fieldActived.map((x) => {
        this.isDisabledContinue =
          this.isDisabledContinue || this.fields[x.substr(0, 6)] === "";
      });
      this.isDisabledContinue = this.isDisabledContinue || !this.isRedyToBuy;
    },
    async getPaymentMethods() {
      try {
        let res = await paymentservice.getPaymentMethods();
        let data = [];
        let allPackage = this.allPackage;
        res.data.map((x) => {
          if (allPackage.filter((f) => f.payment === x.code).length > 0) {
            data.push(x);
          }
        });

        if (this.role === "agent") {
          data = data.filter((x) => x.code === "wallet");
          let wallet_res = await paymentservice.getWalletByUid(this.uid);
          this.wallet = wallet_res.data;
        } else if (
          this.role === "customer" ||
          this.role === undefined ||
          this.role === "" ||
          this.uid === ""
        ) {
          data = data.filter((x) => x.code !== "wallet");
        } else {
          let wallet_res = await paymentservice.getWalletByUid(this.uid);
          this.wallet = wallet_res.data;
        }

        this.paymentMethods = data;
        this.paymentLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
    async getPackage() {
      var gameCode = this.$route.params.code;
      let res = this.tier
        ? await packageservice.getPackageTier(gameCode, this.tier.id)
        : await packageservice.getPackage(gameCode);
      try {
        if (this.paymentMethodCode !== "") {
          this.packages = res.data.filter(
            (x) => x.payment == this.paymentMethodCode
          );
        } else {
          this.packages = res.data;
        }
        this.allPackage = res.data;
        this.packagesLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
    async getGames() {
      try {
        let res = await gameservice.get("games");
        this.game = res.data.find((x) => x.code === this.$route.params.code);
        this.fieldActived = Object.keys(this.game).filter((x) =>
          x.indexOf("field") > -1 &&
          x.indexOf("IsActived") > -1 &&
          x.indexOf("field1IsActived") === -1
            ? this.game[x]
            : false
        );
        this.gameLoaded = true;
      } catch (error) {
        message.error("ไม่สามารถโหลดเกมได้ กรุณาลองอีกครั้ง");
        console.log(error);
      }
    },
    async getBanks() {
      let res = await paymentservice.getBanks();
      try {
        this.banks = res.data;
        this.banksLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
    async onSelectedPayment(p) {
      this.paymentMethodCode = p.code;
      if (this.banks.length === 0 && p.code === "bank") {
        await this.getBanks();
      }
      this.bank = {};
      this.packages = this.allPackage.filter((x) => x.payment == p.code);
    },
    onSelectedBank(b) {
      this.bank = b;
    },
    onSelectedPackage(p) {
      this.price = p.price;
      this.txtPrice =
        (p.price - p.discount) + (this.paymentMethodCode === "wallet" ? "" : ".xx");
      this.packageId = p.id;
      this.gameId = p.gameId;
    },
    showSwal() {
      this.showTermsInfo();
    },
    showTermsInfo() {
      var gamePackage = {
        gameId: this.gameId,
        playerId: this.playerDetail.field1?.uid || this.fields.field1,
        field1: this.fields.field1,
        field2: this.fields.field2,
        field3: this.fields.field3,
        field4: this.fields.field4,
        field5: this.fields.field5,
        playerName: this.playerDetail.field1?.name || "",
        bank: this.bank,
        paymentMethod: this.paymentMethods.find(
          (x) => x.code == this.paymentMethodCode
        ),
        package: this.packages.find((x) => x.id == this.packageId),
        actualPrice: this.price,
      };

      localStorage.setItem("GamePackage", JSON.stringify(gamePackage));
      this.$router.push("/terms");
    },
    onIdChange(value) {
      this.fields.field1 = value.target.value;
    },
    onFieldChange(value, name) {
      this.fields[name] = value;
    },
    async onSearch() {
      this.isPlayerFoundError = false;
      this.spinning = true;

      if (
        this.$route.params.code === "pubg" &&
        this.midasbuy.optionValue === "true"
      ) {
        try {
          let res = await gameservice.getPubgById(this.fields.field1);
          this.playerDetail.field1 = res.data;
          console.log(res.data);
          this.confirmedValue = this.fields.field1;
        } catch (error) {
          if (error.response.data.indexOf("Timed out") > -1)
            this.isPlayerFoundError = true;
          this.playerDetail.field1 = null;
        } finally {
          this.spinning = false;
        }
      } else {
        this.playerDetail.field1 = {
          uid: this.fields.field1,
          name: "",
        };
        this.confirmedValue = this.fields.field1;
        this.spinning = false;
      }
      console.log(this.playerDetail.field1);
    },
    onFieldSearch(name) {
      this.playerDetail[name] = {
        value: this[name],
      };
    },
    async getConfig() {
      try {
        let res = await userservice.getConfig();
        this.midasbuy = res.data.find((x) => x.optionName === "CHECK_MIDASBUY");
        this.configLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
    onClearSearch() {
      this.playerDetail.field1 = null;
      this.confirmedValue = "";
    },
    onClearFieldSearch(name) {
      this.playerDetail[name] = null;
    },
    async getWaitting() {
      try {
        let res = await orderservice.getWaitting();
        if (res.data.length > 0) {
          this.isRedyToBuy = false;
          const swal2 = Swal.mixin({
            confirmButtonText: "ยกเลิกทั้งหมด",
            cancelButtonText: "ดูประวัติการสั่งซื้อ",
            allowOutsideClick: false,
            showCancelButton: true,
            customClass: {
              confirmButton: "btn btn-info",
              cancelButton: "btn btn-default",
            },
            buttonsStyling: false,
          });
          swal2
            .fire({
              title: "คุณต้องทำการชำระเงินก่อนทำรายการใหม่",
              text:
                "คุณมีรายการที่ยังไม่ได้ชำระเงิน " +
                res.data.map((x) => x.orderNo).join(", "),
            })
            .then((result) => {
              if (result.isConfirmed) {
                res.data.map(async (x) => {
                  let req = { orderNo: x.orderNo, status: "cancel" };
                  try {
                    let cancelRes = await paymentservice.updateOrderStatus(req);
                    message.success(`ยกเลิกรายการ ${x.orderNo} สำเร็จ`);
                    this.isRedyToBuy = true;
                  } catch (error) {
                    message.success("ยกเลิกไม่สำเร็จ กรุณาลองอีกครัง");
                    this.isRedyToBuy = false;
                  }
                });
              } else {
                this.$router.push("/purchase/history");
              }
            });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.historyLoaded = false;
      }
    },
    getCurrency(x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data() {
    return {
      code: "",
      uid: "",
      role: "",
      tier: "",
      fieldActived: [],
      midasbuy: {
        optionValue: false,
        optionName: "CHECK_MIDASBUY",
      },
      spinning: false,
      configLoaded: false,
      checkboxes: {
        terms: true,
        terms2: false,
      },
      game: null,
      fields: {
        field1: "",
        field2: "",
        field3: "",
        field4: "",
        field5: "",
      },
      playerDetail: {
        field1: null,
        field2: null,
        field3: null,
        field4: null,
        field5: null,
      },
      isPlayerFoundError: false,
      paymentLoaded: false,
      paymentMethods: [],
      packagesLoaded: false,
      packages: [],
      allPackage: [],
      banks: [],
      bank: {},
      banksLoaded: false,
      price: 0,
      txtPrice: "0",
      paymentMethodCode: "",
      packageId: "",
      confirmedValue: "",
      randId: "",
      gameId: "",
      isDisabledContinue: true,
      isRedyToBuy: true,
      wallet: null,
    };
  },
  watch: {
    packageId: {
      handler(value) {
        this.getIsContinue();
      },
    },
    confirmedValue: {
      handler(value) {
        this.getIsContinue();
      },
    },
    bank: {
      handler(value) {
        this.getIsContinue();
      },
    },
    paymentMethodCode: {
      handler(value) {
        this.getIsContinue();
      },
    },
    "fields.field1": {
      handler(value) {
        this.getIsContinue();
      },
    },
    "fields.field2": {
      handler(value) {
        this.getIsContinue();
      },
    },
    "fields.field3": {
      handler(value) {
        this.getIsContinue();
      },
    },
    "fields.field4": {
      handler(value) {
        this.getIsContinue();
      },
    },
    "fields.field5": {
      handler(value) {
        this.getIsContinue();
      },
    },
    // this.packageId == "" ||
    //         this.confirmedValue == "" ||
    //         (this.paymentMethodCode == "bank" && this.bank.code == undefiled) ||
    //         this.paymentMethodCode == "";
  },
  async mounted() {
    let isback = this.$route.params.isback;

    if (isback) {
      let gamePackage = JSON.parse(localStorage.getItem("GamePackage"));
      if (this.$route.params.code === "pubg") {
        let field1 = {
          uid: gamePackage.playerId,
          name: gamePackage.playerName,
        };
        this.playerDetail.field1 = field1;
        this.confirmedValue = field1;
      }

      this.fields.field1 = gamePackage.field1;
      this.fields.field2 = gamePackage.field2;
      this.fields.field3 = gamePackage.field3;
      this.fields.field4 = gamePackage.field4;
      this.fields.field5 = gamePackage.field5;
      this.gameId = gamePackage.gameId;
      this.bank = gamePackage.bank;
      this.packageId = gamePackage.package.id;
      this.paymentMethodCode = gamePackage.paymentMethod.code;

      this.price = gamePackage.actualPrice;
      this.txtPrice =
        gamePackage.actualPrice +
        (gamePackage.paymentMethod.code === "wallet" ? "" : ".xx");

      if (gamePackage.paymentMethod.code === "bank") {
        await this.getBanks();
      }
    }
  },
  async beforeMount() {
    this.code = this.$route.params.code;
    this.uid = await configuration.getUid();

    if (this.uid !== "") {
      await this.getWaitting();
      let user = await configuration.getIdTokenResult();
      if (user) {
        this.role = user.claims.role;
        let res = await userservice.getUserTier(this.uid);
        this.tier = res.data;
      }
    }

    if (localStorage.getItem("AcceptTerm") && this.uid !== "") {
      this.$router.push("/payment");
    }

    await this.getConfig();
    await this.getPackage();
    await this.getPaymentMethods();
    await this.getGames();
  },
};
</script>

<style lang="scss" scoped>
@import url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/1462889/unicons.css");
@import url("https://fonts.googleapis.com/css2?family=Ropa+Sans&display=swap");
:root {
  --white: #ffffff;
  --light: #f0eff3;
  --black: #000000;
  --dark-blue: #1f2029;
  --dark-light: #353746;
  --red: #da2c4d;
  --yellow: #f8ab37;
  --grey: #ecedf3;
}

.terms-list {
  li {
    font-size: 15px;
    margin-top: 5px;
  }
}

.checkbox-radios {
  .terms {
    font-size: 15px;
  }
}

.patitle {
  font-size: 16px;
  letter-spacing: 1px;
  line-height: 16px;
  font-family: dinm;
  font-weight: 400;
}

.package-wallet {
  cursor: not-allowed;
}

.shop-box {
  width: 100%;
  text-align: center;
  height: 24px;
  .num {
    font-size: 24px;
    display: inline-block;
    position: relative;
    padding-left: 25px;
    font-family: "Ropa Sans", sans-serif;
    color: #fff;
    .icon {
      width: 24px;
      height: 24px;
      left: 0;
      bottom: 4px;
      position: absolute;
    }
  }
  .bonus {
    font-size: 24px;
    color: #ebbe4a;
    display: inline-block;
    vertical-align: bottom;
  }
}

.shop-pic {
  margin-top: 0;
  margin-bottom: 0;
  padding: 16px;
  box-sizing: border-box;
  overflow: hidden;
}

.one-price {
  line-height: 42px;
  padding: 0;
}
.price-box {
  background: #285382;
  text-align: center;
  padding-top: 4px;
  padding-bottom: 4px;
  box-sizing: border-box;
  height: 42px;
  position: relative;
  width: 100%;
}

.money {
  font-size: 20px;
  font-family: "Ropa Sans", sans-serif;
  color: #fff;
  letter-spacing: -0.67px;
}

/* #Primary
================================================== */
.card-body {
  .section {
    padding: 20px 0;
    position: relative;
    width: 100%;
    // display: block;
    text-align: center;
    margin: 0 auto;
  }
  .over-hide {
    overflow: hidden;
  }
  .z-smaller {
    z-index: 100 !important;
    img {
      height: 32px;
    }
    span {
      margin-left: 24px;
    }
  }
  .z-bigger {
    z-index: 100 !important;
  }
}

.background-color {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--dark-blue);
  z-index: 1;
  -webkit-transition: all 300ms linear;
  transition: all 300ms linear;
}
.checkbox:checked ~ .background-color {
  background-color: var(--white);
}

[type="checkbox"]:checked,
[type="checkbox"]:not(:checked),
[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
  width: 0;
  height: 0;
  visibility: hidden;
}
.checkbox:checked + label,
.checkbox:not(:checked) + label {
  position: relative;
  width: 70px;
  display: inline-block;
  padding: 0;
  margin: 0 auto;
  text-align: center;
  margin: 17px 0;
  margin-top: 100px;
  height: 6px;
  border-radius: 4px;
  background-image: linear-gradient(298deg, var(--red), var(--yellow));
  z-index: 100 !important;
}
.checkbox:checked + label:before,
.checkbox:not(:checked) + label:before {
  position: absolute;
  font-family: "unicons";
  cursor: pointer;
  top: -17px;
  z-index: 2;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  -webkit-transition: all 300ms linear;
  transition: all 300ms linear;
}
.checkbox:not(:checked) + label:before {
  content: "\eac1";
  left: 0;
  color: var(--grey);
  background-color: var(--dark-light);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(26, 53, 71, 0.07);
}
.checkbox:checked + label:before {
  content: "\eb8f";
  left: 30px;
  color: var(--yellow);
  background-color: var(--dark-blue);
  box-shadow: 0 4px 4px rgba(26, 53, 71, 0.25), 0 0 0 1px rgba(26, 53, 71, 0.07);
}

.checkbox:checked ~ .section .container .row .col-12 p {
  color: var(--dark-blue);
}

.checkbox-tools:checked + label,
.checkbox-tools:not(:checked) + label {
  position: relative;
  display: inline-block;
  padding: 20px;
  width: 110px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1px;
  margin: 0 auto;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 10px;
  text-align: center;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  text-transform: uppercase;
  color: var(--white);
  -webkit-transition: all 300ms linear;
  transition: all 300ms linear;
}
.checkbox-tools:not(:checked) + label {
  background-color: var(--dark-light);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
.checkbox-tools:checked + label {
  background-color: transparent;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.checkbox-tools:not(:checked) + label:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.checkbox-tools:checked + label::before,
.checkbox-tools:not(:checked) + label::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-image: linear-gradient(298deg, var(--red), var(--yellow));
  z-index: -1;
}
.checkbox-tools:checked + label .uil,
.checkbox-tools:not(:checked) + label .uil {
  font-size: 24px;
  line-height: 24px;
  display: block;
  padding-bottom: 10px;
}

.checkbox:checked
  ~ .section
  .container
  .row
  .col-12
  .checkbox-tools:not(:checked)
  + label {
  background-color: var(--light);
  color: var(--dark-blue);
  box-shadow: 0 1x 4px 0 rgba(0, 0, 0, 0.05);
}

.checkbox-budget:checked + label,
.checkbox-budget:not(:checked) + label {
  position: relative;
  display: inline-block;
  padding: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 260px;
  font-size: 52px;
  line-height: 52px;
  font-weight: 700;
  letter-spacing: 1px;
  margin: 0 auto;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 10px;
  text-align: center;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  text-transform: uppercase;
  -webkit-transition: all 300ms linear;
  transition: all 300ms linear;
  -webkit-text-stroke: 1px var(--white);
  -webkit-text-fill-color: transparent;
  color: transparent;
}
.checkbox-budget:not(:checked) + label {
  background-color: var(--dark-light);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
.checkbox-budget:checked + label {
  background-color: transparent;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.checkbox-budget:not(:checked) + label:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.checkbox-budget:checked + label::before,
.checkbox-budget:not(:checked) + label::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-image: linear-gradient(138deg, var(--red), var(--yellow));
  z-index: -1;
}
.checkbox-budget:checked + label span,
.checkbox-budget:not(:checked) + label span {
  position: relative;
  display: block;
}
.checkbox-budget:checked + label span::before,
.checkbox-budget:not(:checked) + label span::before {
  position: absolute;
  content: attr(data-hover);
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  -webkit-text-stroke: transparent;
  -webkit-text-fill-color: var(--white);
  color: var(--white);
  -webkit-transition: max-height 0.3s;
  -moz-transition: max-height 0.3s;
  transition: max-height 0.3s;
}
.checkbox-budget:not(:checked) + label span::before {
  max-height: 0;
}
.checkbox-budget:checked + label span::before {
  max-height: 100%;
}

.checkbox:checked
  ~ .section
  .container
  .row
  .col-xl-10
  .checkbox-budget:not(:checked)
  + label {
  background-color: var(--light);
  -webkit-text-stroke: 1px var(--dark-blue);
  box-shadow: 0 1x 4px 0 rgba(0, 0, 0, 0.05);
}

.checkbox-payment:checked + label,
.checkbox-payment:not(:checked) + label {
  position: relative;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
  // -webkit-justify-content: center;
  // -moz-justify-content: center;
  // -ms-justify-content: center;
  //justify-content: center;
  -ms-flex-pack: center;
  text-align: center;
  padding: 0;
  padding: 15px 25px;
  width: 95%;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 1px;
  margin: 0 auto;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 16px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  color: var(--dark-blue);
  background-color: #ffffff;
  -webkit-transition: all 300ms linear;
  transition: all 300ms linear;
}
.checkbox-payment:not(:checked) + label::before {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
.checkbox-payment:checked + label::before {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.checkbox-payment:not(:checked) + label:hover::before {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.checkbox-payment:checked + label::before,
.checkbox-payment:not(:checked) + label::before {
  position: absolute;
  content: "";
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  border-radius: 4px;
  z-index: -2;
  background-image: linear-gradient(138deg, var(--red), var(--yellow));
  -webkit-transition: all 300ms linear;
  transition: all 300ms linear;
}
.checkbox-payment:checked + label::after,
.checkbox-payment:not(:checked) + label::after {
  position: absolute;
  content: "";
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  border-radius: 4px;
  z-index: -2;
  background-color: var(--light);
  -webkit-transition: all 300ms linear;
  transition: all 300ms linear;
}
.checkbox-payment:checked + label::after {
  opacity: 0;
}
.checkbox-payment:checked + label .uil,
.checkbox-payment:not(:checked) + label .uil {
  font-size: 20px;
}
.checkbox-payment:checked + label .text,
.checkbox-payment:not(:checked) + label .text {
  position: relative;
  display: inline-block;
  -webkit-transition: opacity 300ms linear;
  transition: opacity 300ms linear;
}

.checkbox:checked
  ~ .section
  .container
  .row
  .col-12
  .checkbox-payment:not(:checked)
  + label,
.checkbox:checked
  ~ .section
  .container
  .row
  .col-12
  .checkbox-payment:checked
  + label {
  background-color: var(--light);
  color: var(--dark-blue);
}
.checkbox:checked
  ~ .section
  .container
  .row
  .col-12
  .checkbox-payment:checked
  + label::after,
.checkbox:checked
  ~ .section
  .container
  .row
  .col-12
  .checkbox-payment:not(:checked)
  + label::after {
  background-color: var(--light);
}

label {
  cursor: pointer;
}
h2,
h3,
h5 {
  font-weight: 600;
  line-height: 1.3;
  color: #1f2949;
}
h2 {
  font-size: 24px;
}
h3 {
  font-size: 18px;
}
// h4 {
//   font-size: 14px;
// }
h5 {
  font-size: 12px;
  font-weight: 400;
}
img {
  max-width: 100%;
  display: block;
}
.container {
  max-width: 99vw;
  margin: 15px auto;
  padding: 0 15px;
}

.top-text-wrapper {
  margin: 20px 0 30px 0;
}
.top-text-wrapper h4 {
  font-size: 24px;
  margin-bottom: 10px;
}
.top-text-wrapper code {
  font-size: 0.85em;
  background: linear-gradient(90deg, #fce3ec, #ffe8cc);
  color: #ff2200;
  padding: 0.1rem 0.3rem 0.2rem;
  border-radius: 0.2rem;
}
.tab-section-wrapper {
  padding: 30px 0;
}

.grid-wrapper {
  display: grid;
  //grid-gap: 30px;
  place-items: center;
  place-content: center;
}
.grid-col-auto {
  grid-template-columns: repeat(auto-fill, minmax(280px, 0.1fr));
  grid-template-rows: auto;
}
.grid-col-1 {
  grid-template-columns: repeat(1, auto);
  grid-template-rows: repeat(1, auto);
  padding-bottom: 16px;
}
.grid-col-2 {
  grid-template-columns: repeat(2, auto);
  grid-template-rows: repeat(1, auto);
  padding-bottom: 16px;
}
.grid-col-3 {
  grid-template-columns: repeat(3, auto);
  grid-template-rows: repeat(1, auto);
  padding-bottom: 16px;
}
.grid-col-4 {
  grid-template-columns: repeat(4, auto);
  grid-template-rows: repeat(1, auto);
  padding-bottom: 16px;
}

/* ******************* Selection Radio Item */

.selected-content {
  text-align: center;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(219, 215, 215, 0);
  border: solid 2px transparent;
  background: #fff;
  height: 100px;
  padding: 15px;
  display: grid;
  grid-gap: 15px;
  place-content: center;
  transition: 0.3s ease-in-out all;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
}

.selected-content:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.selected-content img {
  width: 230px;
  margin: 0 auto;
}
.selected-content h4 {
  font-size: 16px;
  letter-spacing: -0.24px;
  text-align: center;
  color: #1f2949;
}
.selected-content h5 {
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  color: #686d73;
}

.selected-label {
  position: relative;
  width: 100%;
}
.selected-label input {
  display: none;
}
.selected-label .icon {
  width: 20px;
  height: 20px;
  border: solid 2px #e3e3e3;
  border-radius: 50%;
  position: absolute;
  top: 15px;
  left: 15px;
  transition: 0.3s ease-in-out all;
  transform: scale(1);
  z-index: 1;
}
.selected-label .icon:before {
  content: "\f00c";
  position: absolute;
  width: 100%;
  height: 100%;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  font-size: 12px;
  color: #000;
  text-align: center;
  opacity: 0;
  transition: 0.2s ease-in-out all;
  transform: scale(2);
}
.selected-label input:checked + .icon {
  background: #3057d5;
  border-color: #3057d5;
  transform: scale(1.2);
}
.selected-label input:checked + .icon:before {
  color: #fff;
  opacity: 1;
  transform: scale(0.8);
}
.selected-label input:checked ~ .selected-content {
  box-shadow: 0 2px 4px 0 rgba(219, 215, 215, 0.5);
  border: solid 2px #3057d5;
}

//amount
</style>